var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-card-timeline",class:{ 'md-card-plain': _vm.plain }},[_c('ul',{staticClass:"milestones-timeline",class:{ 'timeline-simple': _vm.type === 'simple' }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }